module.exports = __webpack_public_path__ + "static/media/purqr-logo-white-transparant.b82e85c3.png";